import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { getDateString } from "common/date-utils";
import { InsLabelValueTooltip } from "components/widgets/base/common/insLabelValueTooltip";
import { formatPointLabel } from "components/widgets/chart/base/utils";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
/**
 * @this {TooltipFormatterContextObject}
 * @param this tooltipcontext object
 */
export const formatLabel = function formatLabel() {
    if (this.point?.options?.custom) {
        const { xAxisDisplayName, xAxisType, yAxisDisplayName, yAxisFormatKind } = this.point.options.custom;
        const labelValuePairs = [];
        labelValuePairs.push([
            xAxisDisplayName ?? "x",
            xAxisType && xAxisType === "Date" ? getDateString(new Date(this.point.x)) : this.point.x.toString()
        ]);
        labelValuePairs.push([
            yAxisDisplayName ?? "y",
            formatPointLabel(this.point.y || 0, yAxisFormatKind || ChartSelectValueFormatKind.compact)
        ]);
        return renderToStaticMarkup(React.createElement(InsLabelValueTooltip, { labelValuePairs: labelValuePairs }));
    }
    return "";
};
